// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2hDaB","info":"Header_info__JrCWq","breadcrumb":"Header_breadcrumb__3vRMg","hide":"Header_hide__6OKV3","button":"Header_button__kHtDf"};